"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupEventListener = void 0;
const visibility_1 = require("../util/visibility");
const DEFAULT_EVENT_LIST = [
    { event: 'load' },
    { event: 'click' },
];
const CAPTURE_ATTRIBUTES = ['class'];
const LISTENER_DELAY = 300;
const ALL_SELECTOR = "*";
let activatorWindow;
let activatorSubelement;
const viewCallbackRegistry = [];
const setupEventListener = (options) => {
    const { window, secondaryDOMElementList, baseObserver, elementSelectorList, dataLayer, eventCaptureList } = options;
    if (baseObserver() === null) {
        return;
    }
    const handlerWrapper = windowListenerSetup({ elementSelectorList, dataLayer });
    const inmutableCaptureList = eventCaptureList !== undefined ? [...eventCaptureList] : [...DEFAULT_EVENT_LIST];
    const handleEventDOMElement = (element, inmutableCaptureList, add) => () => {
        // The modals does not listen to window registered event
        // const modalList = document.querySelectorAll(".modal");
        // activator = setTimeout(() => { console.log("Waiting to do OP: " + add); }, 300);
        inmutableCaptureList.forEach(e => {
            const { event, options } = e;
            add ? element.addEventListener(event, handlerWrapper, Object.assign({ passive: true }, options)) : element.removeEventListener(event, handlerWrapper);
            //modalList.forEach(m => add ? m.addEventListener(event, handlerWrapper) : m.removeEventListener(event, handlerWrapper));
        });
    };
    const addEventSecondaryElements = () => {
        const secondaryDOMElementListCurrent = secondaryDOMElementList();
        secondaryDOMElementListCurrent !== undefined &&
            secondaryDOMElementListCurrent.length > 0 &&
            Array.from(secondaryDOMElementListCurrent).map(element => handleEventDOMElement(element, inmutableCaptureList, true)).
                forEach(elementSetup => elementSetup());
    };
    const removeEventSecondaryElements = () => {
        const secondaryDOMElementListCurrent = secondaryDOMElementList();
        secondaryDOMElementListCurrent !== undefined &&
            secondaryDOMElementListCurrent.length > 0 &&
            Array.from(secondaryDOMElementListCurrent).map(element => handleEventDOMElement(element, inmutableCaptureList, false)).
                forEach(elementSetup => elementSetup());
    };
    const removeEventWindow = () => {
        handleEventDOMElement(window, inmutableCaptureList, false)();
        removeEventSecondaryElements();
    };
    const addEventWindow = () => {
        removeEventWindow();
        if (activatorWindow !== null) {
            //console.log("Clearing previous setup (activatorWindow)");
            clearTimeout(activatorWindow);
            activatorWindow = null;
        }
        activatorWindow = setTimeout(handleEventDOMElement(window, inmutableCaptureList, true), LISTENER_DELAY);
        if (activatorSubelement !== null) {
            //console.log("Clearing previous setup (activatorSubelement)");
            clearTimeout(activatorSubelement);
            activatorSubelement = null;
        }
        activatorSubelement = setTimeout(addEventSecondaryElements, LISTENER_DELAY);
    };
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    const callback = mutationObserverHandler({
        CaputreAttributeList: CAPTURE_ATTRIBUTES,
        listenerSetupCallback: addEventWindow,
        elementSelectorList: elementSelectorList,
        dataLayer
    });
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    // Start observing the target node for configured mutations
    observer.observe(baseObserver(), config);
    addEventWindow();
    const cleanCallback = () => {
        observer.disconnect();
        removeEventWindow();
        if (activatorWindow !== null) {
            clearTimeout(activatorWindow);
            activatorWindow = null;
        }
        if (activatorSubelement !== null) {
            clearTimeout(activatorSubelement);
            activatorSubelement = null;
        }
    };
    return cleanCallback;
};
exports.setupEventListener = setupEventListener;
const mutationObserverHandler = (setupOptions) => 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(mutationsList, observer) => {
    const { CaputreAttributeList, listenerSetupCallback, elementSelectorList, dataLayer } = setupOptions;
    const matchEventType = elementSelectorList.find(eventTypeGroup => eventTypeGroup.type === "view");
    //console.log({ mutationsList, matchEventType })
    if (matchEventType === undefined)
        return;
    const mutationHasCoincidence = matchEventType.selectorPairList.filter(eventEntry => mutationsList.some(mutatedElements => mutatedElements.target.matches(eventEntry.selector)));
    //console.log({ mutationHasCoincidence })
    // const mutationHasCoincidence = mutationsList.filter(mutatedElements => matchEventType.selectorPairList.find(eventEntry => (mutatedElements.target as HTMLElement).matches(eventEntry.selector)))
    if (mutationHasCoincidence.length >= 0) {
        mutationHasCoincidence.forEach(mutationEventRecord => {
            const node = mutationsList.find(mutatedElements => mutatedElements.target.matches(mutationEventRecord.selector));
            tryRecordView({
                dataLayer,
                viewsRegistry: viewCallbackRegistry,
                activeNode: node === null || node === void 0 ? void 0 : node.target,
                CheckViewCallback: visibility_1.isElementInViewPort
            })(mutationEventRecord);
        });
        return;
    }
    for (const mutation of mutationsList) {
        const { type } = mutation;
        const { target, addedNodes } = mutation;
        // const matchElementsByTarget = matchEventType.selectorPairList.filter(e => (target as HTMLElement).matches(e.selector));
        //console.log({ match: target.matches("header"), target, mutation });
        if (type === 'childList') {
            //console.log('A child node has been added or removed, should reset the listeners');
            //listenerRemoveCallback();
            listenerSetupCallback();
            if (addedNodes !== undefined && addedNodes.length > 0) {
                Array.from(addedNodes).forEach(node => {
                    // SKIP Text Nodes
                    if (node.nodeType === 3)
                        return;
                    //console.log(`Name: ${node.nodeName} Type: ${node.nodeType}`);
                    const matchElements = matchEventType.selectorPairList.filter(e => node.matches(e.selector));
                    matchElements.forEach(tryRecordView({
                        dataLayer,
                        viewsRegistry: viewCallbackRegistry,
                        activeNode: node,
                        CheckViewCallback: visibility_1.isElementInViewPort
                    }));
                });
            }
        }
        else if (type === 'attributes' && mutation.attributeName !== null && CaputreAttributeList.includes(mutation.attributeName)) {
            //isElementInViewPort()
            const matchEventType = elementSelectorList.find(eventTypeGroup => eventTypeGroup.type === "view");
            if (matchEventType === undefined)
                return;
            const targetUnbox = target;
            if (targetUnbox.matches === undefined)
                return;
            const isModalShown = targetUnbox.matches("body.modal-open");
            if (isModalShown) {
                const matchElementsContainer = matchEventType.selectorPairList.filter(e => targetUnbox.querySelector(e.selector));
                matchElementsContainer.forEach(m => {
                    const { selector } = m;
                    const targetElement = targetUnbox.querySelector(selector);
                    tryRecordView({
                        dataLayer,
                        viewsRegistry: viewCallbackRegistry,
                        activeNode: targetElement,
                        CheckViewCallback: visibility_1.isElementInViewPort
                    })(m);
                });
            }
        }
    }
};
const tryRecordView = (recordView) => (eventCaller) => {
    const { dataLayer, viewsRegistry, activeNode, CheckViewCallback } = recordView;
    // The ammount allows to sum-up X eventos as views
    const { callback, selector, amount = 1 } = eventCaller;
    const finding = viewsRegistry.filter(registry => registry.selector === selector);
    if (finding.length >= amount)
        return;
    const isInViewPort = CheckViewCallback(window, activeNode);
    if (!isInViewPort)
        return;
    const success = callback(dataLayer, Object.assign({}, activeNode.dataset));
    success && viewsRegistry.push(eventCaller);
};
const windowListenerSetup = (options) => (event) => {
    const { elementSelectorList, dataLayer } = options;
    return EventHandler({ event, elementSelectorList, dataLayer });
};
const EventHandler = (options) => {
    const { event, elementSelectorList, dataLayer } = options;
    //console.log("Capturing event ", event);
    const { target, type } = event;
    if (target === null || target === undefined)
        return;
    const targetUnboxed = target;
    const matchEventType = elementSelectorList.find(eventTypeGroup => eventTypeGroup.type === type);
    if (matchEventType === undefined || matchEventType === null)
        return;
    const { indirect = false, selectorPairList } = matchEventType;
    if (targetUnboxed.matches === undefined && !indirect)
        return;
    if (selectorPairList === null || selectorPairList === undefined)
        return;
    const matchElements = selectorPairList.filter(e => indirect || (typeof targetUnboxed.matches !== "undefined" && targetUnboxed.matches(e.selector)));
    if (matchElements !== undefined && matchElements.length > 0) {
        matchElements.forEach(matchElement => {
            const { callback, selector, exclude } = matchElement;
            const targetClone = indirect ? targetUnboxed.querySelector(selector) : targetUnboxed;
            if (targetClone === null)
                return;
            if (exclude !== undefined && exclude !== null && targetClone.matches(exclude)) {
                return;
            }
            const isParentSelector = selector !== null && selector.trim().indexOf(ALL_SELECTOR) === selector.trim().length - 1;
            let parentElement = null;
            let parentDataset = {};
            if (isParentSelector) {
                parentElement = targetClone.parentElement;
                while (parentElement !== null && parentElement.matches(selector)) {
                    parentElement = parentElement.parentElement;
                    const { dataset: parentDatasetTemp = null } = parentElement !== null ? parentElement : {};
                    if (parentDatasetTemp !== undefined && parentDatasetTemp !== null)
                        parentDataset = Object.assign(Object.assign({}, parentDataset), parentDatasetTemp);
                }
            }
            if (indirect) {
                tryRecordView({
                    dataLayer,
                    viewsRegistry: viewCallbackRegistry,
                    activeNode: targetClone,
                    CheckViewCallback: visibility_1.isElementInViewPort
                })(matchElement);
                return;
            }
            const { dataset } = targetClone;
            callback(dataLayer, Object.assign(Object.assign({}, parentDataset), dataset));
        });
    }
};
//# sourceMappingURL=index.js.map